import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { CommonIntegrationContainerProps } from "models/propTypes/integrationsPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { IntegrationFormTypes, SettingsFormTypes } from "models/formTypes";
import { AppCategory } from "models/enums/apps";
//#endregion
//#region components
import BillogramFormContainer from "./forms/billogramFormContainer";
import CustomIntegrationFormContainer from "./forms/customIntegrationFormContainer";
import SimpleFormContainer from "./forms/simpleFormContainer";
import StripeConnectFormContainer from "./forms/stripeConnectFormContainer";
import VismaAdvisorFormContainer from "./forms/vismaAdvisorFormContainer";
//#endregion
import { useSettingsService } from "serviceHooks";

const CommonIntegrationContainer: ForwardRefRenderFunction<FormHandles, CommonIntegrationContainerProps> = (
  props,
  ref
) => {
  const settingsService = useSettingsService();
  const onQbisSettingsUpdate = async (values: IntegrationFormTypes.SimpleIntegration) => {
    const qbis = { aPIKey: values.apiKey, isActive: values.isActive } as WintSuperkollAPIModel.QbisPut;
    await settingsService.updateQbis(qbis);

    return (
      props.submitResultFormatter &&
      props.submitResultFormatter({
        ...props,
        isActive: values.isActive,
        appData: { ...props.appData, ...qbis },
      } as SettingsFormTypes.IntegrationItem)
    );
  };

  const onJobbileSettingsUpdate = async (values: any) => {
    const jobbile = { aPIKey: values.apiKey, isActive: values.isActive } as WintSuperkollAPIModel.JobbilePut;
    await settingsService.updateJobbile(jobbile);

    return (
      props.submitResultFormatter &&
      props.submitResultFormatter({
        ...props,
        isActive: values.isActive,
        appData: { ...props.appData, ...jobbile },
      } as SettingsFormTypes.IntegrationItem)
    );
  };

  switch (props.appCategory) {
    case AppCategory.Billogram: {
      return (
        <BillogramFormContainer
          ref={ref}
          submitResultFormatter={props.submitResultFormatter}
          {...props}
        ></BillogramFormContainer>
      );
    }
    case AppCategory.Qbis: {
      return (
        <SimpleFormContainer
          ref={ref}
          {...props}
          isActiveText={TranslationKeys.Integrations.EnableQbisConnection}
          handleSubmit={onQbisSettingsUpdate}
        ></SimpleFormContainer>
      );
    }
    case AppCategory.Jobbile: {
      return (
        <SimpleFormContainer
          ref={ref}
          {...props}
          isActiveText={TranslationKeys.Integrations.EnableJobbileConnection}
          handleSubmit={onJobbileSettingsUpdate}
        ></SimpleFormContainer>
      );
    }
    case AppCategory.Stripe: {
      return <StripeConnectFormContainer ref={ref} {...props}></StripeConnectFormContainer>;
    }
    case AppCategory.VismaAdvisor: {
      return <VismaAdvisorFormContainer ref={ref} {...props}></VismaAdvisorFormContainer>;
    }
    default: {
      return (
        <CustomIntegrationFormContainer
          ref={ref}
          submitResultFormatter={props.submitResultFormatter}
          {...props}
        ></CustomIntegrationFormContainer>
      );
    }
  }
};
export default forwardRef(CommonIntegrationContainer);
